import React from 'react'
import InputField from './InputFeild'
import Button from './Button'
import twitter from "../images/svg/twitter.svg"
import fb from "../images/svg/facebook.svg"
import instagram from "../images/svg/instagram.svg"
import google from "../images/svg/google.svg"
import linkedin from "../images/svg/linkedin.svg"
import fb_white from "../images/svg/svg1/fb-white.svg"
import insta from "../images/svg/svg1/insta-white.svg"
import google_white from "../images/svg/svg1/google-white.svg"
import linkedin_white from "../images/svg/svg1/linkedin-white.svg"
import twitter_white from "../images/svg/svg1/twitter-white.svg"
const Footer = (props) => {
  if(props.isColour){
    return(
      <div className="text-center bg-black text-white p-10">
  <div className="container mx-auto md:w-2/3 sm:w-full ">
   
      <div className=" md:text-4xl sm:text-2xl text-center">Stay up to date with our latest news & offers</div>
           <div className="container mx-auto p-4 md:w-2/3 sm:w-full flex md:flex-row flex-col justify-center items-center">

          <div className=" md:basis-3/4 mx-auto w-full align-middle">
            <InputField
              type="text" placeholder="Email address"/>
          </div>

          <div className="my-auto md:p-0 p-5">
            <Button label="SUBMIT" isColour={true}/>
             
          </div>

        </div>
       <div className=" pb-10 border-b-2 border-gray-400">
        I agree to subscribe and give consent to receiving marketing emails.
       </div>
      <div className="md:m-5 p-5 flex-wrap flex flex-row justify-between">
<div>
            <a href="/"  >Home</a>
          </div>
           <div>
            <a href="/offer"  >Offer</a>
          </div>
           <div>
            <a href="/room"  >Stay</a>
          </div>
           <div>
            <a href="/restaraunt"  > Restaurant</a>
          </div>
          <div>
            <a href="/events"  >Events</a>
          </div>
          <div>
            <a href="/halls"  >Explore</a>
          </div>
          <div>
            <a href="/gallery"  >Gallery</a>
          </div>
           <div>
            <a href="/contact"  >Contact Us</a>
          </div>
        
      </div>
       <div className=" w-1/2 mx-auto flex flex-row justify-between">
        <img src={fb_white} height="20px" width="20px" alt="fb"/>
         <img src={insta} height="20px" width="20px" alt="instagram"/>
        <img src={twitter_white} height="20px" width="20px" alt="twitter"/>
        <img src={linkedin_white} height="20px" width="20px" alt="linkedIn"/>
        <img src={google_white} height="20px" width="20px" alt="google"/>
       
       </div>
       <div className="text-center p-7">
    © 2022 Hotel Sarvoday All rights reserved
   
  </div>
      </div>
      
</div>
    )
  }
  else{
  return (
    <div className="text-center bg-[#fff4f4] text-black p-10">
  <div className="container mx-auto md:w-2/3 sm:w-full ">
   
      <div className=" md:text-4xl sm:text-2xl text-center">Stay up to date with our latest news & offers</div>
           <div className="container mx-auto p-4 md:w-2/3 sm:w-full flex md:flex-row flex-col justify-center items-center">

          <div className="md:basis-3/4 mx-auto w-full align-middle">
            <InputField
              type="text" placeholder="Email address"/>
          </div>

          <div className="my-auto md:p-0 p-5">
            <Button label="SUBMIT" isColour="black"/>
             
          </div>

        </div>
       <div className=" pb-10 border-b-2 border-gray-400">
        I agree to subscribe and give consent to receiving marketing emails.
       </div>
      <div className="md:m-5 p-5 flex-wrap flex flex-row justify-between">
<div>
            <a href="/"  >Home</a>
          </div>
           <div>
            <a href="/offer"  >Offer</a>
          </div>
           <div>
            <a href="/room"  >Stay</a>
          </div>
           <div>
            <a href="/restaraunt"  > Restaurant</a>
          </div>
          <div>
            <a href="/events"  >Events</a>
          </div>
          <div>
            <a href="/halls"  >Explore</a>
          </div>
          <div>
            <a href="/gallery"  >Gallery</a>
          </div>
           <div>
            <a href="/contact"  >Contact Us</a>
          </div>
        
      </div>
       <div className=" w-1/2 mx-auto flex flex-row justify-between">
        <img src={fb} height="20px" width="20px" alt="fb"/>
         <img src={instagram} height="20px" width="20px" alt="instagram"/>
        <img src={twitter} height="20px" width="20px" alt="twitter"/>
        <img src={linkedin} height="20px" width="20px" alt="linkedIn"/>
        <img src={google} height="20px" width="20px" alt="google"/>
       
       </div>
       <div className="text-center p-7">
    © 2022 Hotel Sarvoday All rights reserved
   
  </div>
      </div>
      
</div>
  )}
}

export default Footer
